<template>
    <v-app-bar
      app
      dark
      height="130px"
      src="../assets/header-flower.jpg"
    >
      <v-app-bar-title>
        <img
          src="../assets/logo-midas.png"
          height="60"
          alt=""
        />
      </v-app-bar-title>
    </v-app-bar>
</template>
<script>
    export default {
      name: "HeaderBar",
    };
    </script>